import { createStore } from "@stencil/store";

export const productDynamic = createStore({
    loaded: false,
    adminBar: {}
} as ProductDynamicData);

export interface ProductDynamicData {
    loaded: boolean;
    adminBar: AdminBarProduct;
    eventId: string;
}

export interface AdminBarProduct {
    name?: string;
    link: string;
    homeQuantity: string;
    externalQuantity: string;
    availability: string;
    overwrite: boolean;

    distributors: AdminBarProductDistributor[];
    set?: AdminBarProduct[];
}

export interface AdminBarProductDistributor {
    name: string;
    time: string;
    quantity: string;
    unavailableMode: string;
    warning: string;
    overwrite: boolean;
}
